module.exports = __webpack_public_path__ + "img/aston-main.73a18a7e.jpg";